import { toast } from 'sonner';

const toastStyle = {
    default: {
        padding: '1rem',
    }
};

export const toastUtils = {
  success: (message: string, description?: string) => toast.success(message, {description, style: {...toastStyle.default}}),
  error: (message: string, description?: string) => toast.error(message, {description, style: {...toastStyle.default}}),
  info: (message: string, description?: string) => toast.info(message, {description, style: {...toastStyle.default}}),
  warning: (message: string, description?: string) => toast.warning(message, {description, style: {...toastStyle.default}}),
  loading: (message: string) => toast.loading(message, {style: {...toastStyle.default}}),
  dismiss: (id: string | number) => toast.dismiss(id),

};
